import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const KidIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M37.1349 59.6242C36.7444 59.3785 33.3385 57.1122 32.8135 52.5121C32.2346 47.4893 30.1076 47.0794 29.2056 46.8886C28.196 46.6839 26.5671 46.8475 25.3285 47.9807C23.9689 49.2092 23.3497 51.3113 23.5516 54.0551C24.3862 65.7391 19.2976 74.4208 9.56445 77.8746"
                stroke={color}
                strokeWidth="6"
                strokeLinecap="round"
            />
            <path
                d="M7.89746 90.1603C19.8249 115.863 48.1359 132.476 80.0004 132.476C111.879 132.476 140.176 115.863 152.103 90.1603"
                stroke={color}
                strokeWidth="6"
                strokeLinecap="round"
            />
            <path
                d="M51.6524 66.2098H87.466C87.466 53.2577 96.0475 33.5611 114.496 31.5669C116.466 31.3537 117.588 31.5668 117.588 34.0411V42.6144C117.588 42.6144 127.733 49.8261 132.649 53.6593C140.149 59.5081 132.983 66.2098 128.13 66.2098H117.588L128.967 114.405L128.13 117.802L116.274 123.371L113.739 122.27C113.739 122.27 106.543 92.4828 78.9315 92.4828C51.3199 92.4828 44.1242 122.27 44.1242 122.27L41.6438 123.371L30.7592 116.923L29.7305 114.405C29.7305 114.405 38.0998 81.9402 39.605 76.5851C41.1102 71.23 42.279 66.2098 51.6524 66.2098Z"
                stroke={color}
                strokeWidth="6"
            />
        </svg>
    );
};
